import { render, staticRenderFns } from "./SdFoldCards.vue?vue&type=template&id=09ff2ff1&scoped=true"
import script from "./SdFoldCards.vue?vue&type=script&lang=js"
export * from "./SdFoldCards.vue?vue&type=script&lang=js"
import style0 from "./SdFoldCards.vue?vue&type=style&index=0&id=09ff2ff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ff2ff1",
  null
  
)

export default component.exports